import api from "../../api";

class SpecialEvent {
  index() {
   return api.get('evento/especial');
  }

  store(data) {
    return api.post('evento/especial', data);
  }

  show(id) {
    return api.get(`evento/especial/${id}`);
  }

  edit(id) {
    return api.put(`evento/especial/${id}`);
  }

  update(id, data) {
    return api.put(`evento/especial/${id}`, data);
  }

  updateWithHistory(id, data) {
    return api.put(`evento/especial/history/${id}`, data);
  }

  updateProposeCancel(id) {
    return api.put(`evento/especial/propose/${id}`);
  }

  restore(id) {
    return api.put(`evento/especial/restore/${id}`);
  }

  destroy(id) {
    return api.delete(`evento/especial/${id}`);
  }
}

export default new SpecialEvent();
